import { useState, useEffect, useCallback, useMemo } from "react"
import Sidebar from "../components/Sidebar";
import LoanHistory from "../components/LoanHistory";
import Notification from "../components/Notification";
import LoanCalculator from "../components/LoanCalculator";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClone, faCircleNotch, faDownload, faTrash, faChartSimple, faUsers, faGraduationCap, faHeadset, faArrowUpRightFromSquare, faSackDollar, faLock } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { Link } from "react-router-dom";
import { GaugeComponent } from 'react-gauge-component';

//FILE UPLOAD
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

function Loan() {
  const { user } = useUser();
  //CLEAR LOCAL Storage
  localStorage.clear();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
    const r = await getRate(currencyCode);
    if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [assethistory, setAssethistory] = useState([]);
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [wallet, setWallet] = useState([]);
  const [activeTab, setActiveTab] = useState("payments");
  const [collat, setCollat] = useState("BTC");
  const [coinBal, setCoinBal] = useState(0);
  const [files, setFiles] = useState([]);
  const [fileName, setFileName] = useState();
  const [fileType, setFileType] = useState("");
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [documents, setDocuments] = useState([]);
  const assetsData = [
    {
        "symbol": "BTC",
        "name": "Bitcoin",
        "id": 1,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/1.png"
    },
    {
        "symbol": "ETH",
        "name": "Ethereum",
        "id": 1027,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png"
    },
    {
        "symbol": "LTC",
        "name": "Litecoin",
        "id": 2,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/2.png"
    },
    {
        "symbol": "USD",
        "name": "US Dollar",
        "type": "fiat",
        "image": "https://flagcdn.com/w40/us.png"
    },
    {
        "symbol": "GBP",
        "name": "British Pound",
        "type": "fiat",
        "image": "https://flagcdn.com/w40/gb.png"
    },
    {
        "symbol": "EURO",
        "name": "Euro",
        "type": "fiat",
        "image": "https://flagcdn.com/w40/eu.png"
    },
    {
        "symbol": "USDT",
        "name": "Tether",
        "id": 825,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/825.png"
    },
    {
        "symbol": "USDC",
        "name": "USD Coin",
        "id": 3408,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png"
    },
    {
        "symbol": "BNB",
        "name": "BNB",
        "id": 1839,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/1839.png"
    },
    {
        "symbol": "BCH",
        "name": "Bitcoin Cash",
        "id": 1831,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/1831.png"
    },
    {
        "symbol": "XRP",
        "name": "XRP",
        "id": 52,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/52.png"
    },
    {
        "symbol": "XLM",
        "name": "Stellar",
        "id": 512,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/512.png"
    },
    {
        "symbol": "DOGE",
        "name": "Dogecoin",
        "id": 74,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/74.png"
    },
    {
        "symbol": "TRX",
        "name": "TRON",
        "id": 1958,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/1958.png"
    },
    {
        "symbol": "SOL",
        "name": "Solana",
        "id": 5426,
        "type": "crypto",
        "image": "https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png"
    }
  ];
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwallet: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setWallet(data.wallet);
      }
    })
    .catch(err => {
      
    })
  }, [user]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          amount: 0,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        amount: 0,
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
            amount: 0,
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const walletMap = wallet.reduce((acc, item) => {
      const key = item.coinName?.trim().toLowerCase();
      acc[key] = parseFloat(item.balance) || 0;
      return acc;
    }, {});
    const applyWalletBalance = (list, categoryTotal) => {
      let categorySum = 0;
      const result = list.map(item => {
        const key = item.name?.trim().toLowerCase();
        const matchedBalance = walletMap[key];
        const amount = matchedBalance || 0;
        const value = amount * item.price;
        categorySum += value;
        return {
          ...item,
          amount: matchedBalance || 0
        };
      });
      return { result, categorySum };
    };
    const { result: cryptoWithBalance } = applyWalletBalance(crypto);
    const { result: fiatWithBalance } = applyWalletBalance(fiat);
    const { result: stockWithBalance } = applyWalletBalance(stock);
    const merged = [
      ...cryptoWithBalance,
      ...fiatWithBalance,
      ...stockWithBalance
    ];
    const sorted = merged.sort((a, b) => {
      if (b.amount > 0 && a.amount === 0) return 1;
      if (a.amount > 0 && b.amount === 0) return -1;
      return a.name.localeCompare(b.name);
    });
    setAssethistory(sorted);
  }, [crypto, fiat, stock, wallet]);
    const symbolToAmountMap = useMemo(() => {
        const map = {};
        for (const item of assethistory) {
            if (!item || !item.symbol) continue;
            const key = item.symbol.trim().toLowerCase();
            map[key] = item.amount || 0;
        }
        return map;
    }, [assethistory]);
    const getBalanceBySymbol = useCallback((symbol) => {
        if (!symbol) {
            setCoinBal(0);
            return;
        }
        const key = symbol.trim().toLowerCase();
        const balance = symbolToAmountMap[key] || 0;
        setCoinBal(balance);
    }, [symbolToAmountMap]);
    useEffect(() => {
        getBalanceBySymbol(collat);
    }, [collat, getBalanceBySymbol])
    useEffect(() => {
        if(fileType && fileName){
        setDisable(false);
        }else{
        setDisable(true);
        }
    }, [fileType, fileName]);
    const deleteFile = (id) =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/loan.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ deleteupload: true, id: id })
        })
        .then(response => response.json())
        .then(data => {
        if (data.status === "success") {
            setLoading(false);
            toast.success(data.result);
            setTimeout(() => window.location.reload(), 1200);
        }else{
            toast.error(data.message);
        }
        })
        .catch(err => {
        setLoading(false);
        })
    }
    const ValidateUpload = () =>{
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/loan.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ upload: true, filename: fileType, id_photo: fileName })
        })
        .then(response => response.json())
        .then(data => {
        if (data.status === "success") {
            setLoading(false);
            toast.success(data.result);
            setTimeout(() => window.location.reload(), 1200);
        }else{
            toast.error(data.message);
        }
        })
        .catch(err => {
        console.error(err)
        setLoading(false);
        })
    }
    useEffect(() => {
       fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
         credentials: "include",
         method: "POST",
         headers: {
           "Content-Type": "application/json"
         },
         body: JSON.stringify({ fetchDocument: true })
       })
       .then(response => response.json())
       .then(data => {
         if (data.status === "success") {
           setDocuments(data.documents);
         }
       })
       .catch(err => {
        console.error('Error fetching document!')
       })
    }, [user]);
    const downloadFile = async (docPathOrUrl, fallbackName) => {
        let url;
        if (docPathOrUrl.startsWith('http')) {
            url = docPathOrUrl;
        } else if (docPathOrUrl.startsWith('/')) {
            url = `${window.location.origin}${docPathOrUrl}`;
        } else {
            url = `/uploads/${docPathOrUrl}`;
        }
        const res = await fetch(url, {
        method: 'GET',
        credentials: 'include'
        });
        if (!res.ok) throw new Error(`Network error: ${res.status}`);
        const blob = await res.blob();
        const filename = fallbackName || docPathOrUrl.split('/').pop();
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl);
    };

  const [interest, setInterest] = useState(0);
  const [borrowered, setBorrowered] = useState(0);
  const [paid, setPaid] = useState(0);
  const [loanOffer, setLoanOffer] = useState([]);
  const [allLoan, setAllLoan] = useState([]);
  const [activeLoan, setActiveLoan] = useState([]);
  const [loanbalance, setLoanBalance] = useState(0);
  const [countedLoan, setCountedLoan] = useState([]);
  const [collateral, setCollateral] = useState([]);
  const [payments, setPayments] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchloan: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        //active loan
        const updatedSavings2 = data.activeloan.map(tx => {
          let logo = null;
          let symbol = null;
          let price = 1;
          let c_symbol = null;
          let c_logo = null;
          const asset = assethistory.find(asset => asset.name === tx.method);
          if (asset) {
            logo = asset.logo;
            symbol = asset.symbol;
            price = asset.price;
          }
          const asset1 = assethistory.find(asset => asset.name === tx.collateral_method);
          if (asset1) {
            c_logo = asset1.logo;
            c_symbol = asset1.symbol;
          }
          return {
            ...tx,
            logo,
            price,
            symbol,
            c_symbol,
            c_logo,
          };
        });
        setActiveLoan(updatedSavings2);
        //all loan
        const updatedSavings1 = data.allloan.map(tx => {
          let logo = null;
          let symbol = null;
          let c_symbol = null;
          let c_logo = null;
          const asset = assethistory.find(asset => asset.name === tx.method);
          if (asset) {
            logo = asset.logo;
            symbol = asset.symbol;
          }
          const asset1 = assethistory.find(asset => asset.name === tx.collateral_method);
          if (asset1) {
            c_logo = asset1.logo;
            c_symbol = asset1.symbol;
          }
          return {
            ...tx,
            logo,
            symbol,
            c_symbol,
            c_logo,
          };
        });
        setAllLoan(updatedSavings1);
        //counted loan
        const updatedSavings = data.countedloan.map(tx => {
          let logo = null;
          let price = 1;
          let c_logo = null;
          const asset = assethistory.find(asset => asset.name === tx.method);
          if (asset) {
            logo = asset.logo;
            price = asset.price;
          }
          const asset1 = assethistory.find(asset => asset.name === tx.collateral_method);
          if (asset1) {
            c_logo = asset1.logo;
          }
          return {
            ...tx,
            logo,
            price,
            c_logo,
          };
        });
        setCountedLoan(updatedSavings);
        const totalBorrowed = updatedSavings.reduce((sum, loan) => {
            return sum + (parseFloat(loan.amount.replace(/,/g, '') * loan.price) || 0);
        }, 0);
        const totalLoanBalance = updatedSavings2.reduce((sum, loan) => {
            return sum + (parseFloat(loan.remaining.replace(/,/g, '') * loan.price) || 0);
        }, 0);
        const totalInterest = updatedSavings.reduce((sum, loan) => {
            return sum + (parseFloat(loan.interest_amount.replace(/,/g, '') * loan.price) || 0);
        }, 0);
        setInterest(totalInterest);
        setLoanBalance(totalLoanBalance);
        setBorrowered(totalBorrowed);
      }
    })
    .catch(err => {
    })
  }, [user, assethistory]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchcollateral: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedSavings = data.collateral.map(tx => {
          let logo = null;
          const asset = assethistory.find(asset => asset.name === tx.method);
          if (asset) {
            logo = asset.logo;
          }
          return {
            ...tx,
            logo,
          };
        });
        setCollateral(updatedSavings);
      }
    })
    .catch(err => {
    })
  }, [user, assethistory]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchpayments: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedSavings = data.payments.map(tx => {
          let logo = null;
          const asset = assethistory.find(asset => asset.name === tx.method);
          if (asset) {
            logo = asset.logo;
          }
          return {
            ...tx,
            logo,
          };
        });
        setPayments(updatedSavings);
      }
    })
    .catch(err => {
    })
  }, [user, assethistory]);
  useEffect(() => { 
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchpaidpayments: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setPaid(data.paid);
      }
    })
    .catch(err => {
    })
  }, [user, assethistory]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchoffer: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoanOffer(data.offers);
      }
    })
    .catch(err => {
    })
  }, [user]);
  const periodLabel = (period, qty) => {
    const map = { y: 'Year', m: 'Month', w: 'Week', d: 'Day' };
    const base = map[String(period)] || 'Year';
    return (Number(qty) === 1) ? base : `${base}s`;
  };
  const getCreditColor = (score) => {
    if (score >= 800) return { color: "#00FF15", label: "Excellent" };
    if (score >= 740) return { color: "#95ff87ff", label: "Very Good" };
    if (score >= 670) return { color: "#ffc107", label: "Good" };
    if (score >= 580) return { color: "#fd7e14", label: "Fair" };
    return { color: "#FF2121", label: "Poor" };
  };
  const creditInfo = getCreditColor(user?.credit_score || 0);
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Loan" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Loan" icon={<FontAwesomeIcon icon={faClone} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row mt-2">
                <div className="col-lg-4 col-md-6">
                    <div className="mycard p-3">
                      <div className="d-flex justify-content-between align-items-start">
                        <div className="d-flex align-items-start w-50">
                          <div className="d-flex align-items-center justify-content-center mycard" style={{width:'50px',height:'50px',backgroundColor:'#ff6b351c'}}>
                            <p className="fw-bold fs-4 mb-0 text-prime">{getCurrencySymbol(user?.currency)}</p>
                          </div>
                          <div className="ms-2">
                            <p className="mb-0 fw-semibold lh-1" style={{fontSize:'14px'}}>Loan Balance</p>
                            <p className="mb-0 fs-4" style={{fontWeight:'900',lineHeight:'120%'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(user?.loan_balance)}</p>
                            <Link to="/withdraw" state={{route:'loan'}} className="myBtn rounded-pill px-3 py-2 fw-bold d-inline-block mt-2" style={{fontSize:'13px'}}>Withdraw</Link>
                          </div>
                        </div>
                        <div className="d-flex align-items-start w-50">
                          <div className="d-flex align-items-center justify-content-center mycard" style={{width:'50px',height:'50px',backgroundColor:'#ff6b351c'}}>
                            <p className="fw-bold fs-4 mb-0 text-prime"><FontAwesomeIcon icon={faLock} style={{fontSize: '16px'}} /></p>
                          </div>
                          <div className="ms-2">
                            <p className="mb-0 fw-semibold lh-1" style={{fontSize:'14px'}}>Equity Lock</p>
                            <p className="mb-0 fs-4" style={{fontWeight:'900',lineHeight:'120%'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(user?.equity)}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mycard p-3 mt-2">
                      <div className="d-flex justify-content-between align-items-start">
                        <div className="d-flex align-items-center ">
                          <div className="d-flex align-items-center justify-content-center mycard" style={{width:'50px',height:'50px',backgroundColor:'#ff6b351c'}}>
                            <p className="fw-bold fs-4 mb-0 text-prime"><FontAwesomeIcon icon={faSackDollar} style={{fontSize: '16px'}} /></p>
                          </div>
                          <div className="ms-2">
                            <p className="mb-0 fw-semibold lh-1" style={{fontSize:'14px'}}>Loan Limit</p>
                            <p className="mb-0 fs-4" style={{fontWeight:'900',lineHeight:'120%'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(loanbalance * rate)}</p>
                            <p className="mb-0 lh-1" style={{fontSize:'14px'}}>/ {getCurrencySymbol(user?.currency)}{formatCurrency(user?.maxloan * rate)} limit</p>
                          </div>
                        </div>
                        <Link to="/getloan" className="myBtn rounded-pill px-3 py-2 fw-bold d-inline-block noLink" style={{fontSize:'13px'}}>Get a Loan</Link>
                      </div>
                      <div className="d-flex justify-content-between mt-3">
                      {Array(10)
                        .fill()
                        .map((_, i) => {
                          const balper = ((Number(loanbalance) * Number(rate) / Number(user?.maxloan)) * 100).toFixed(2);
                          const isActive = i < balper / 10;
                          let activeColor, inactiveColor;
                          activeColor = "#ff6b35";
                          inactiveColor = "#ff6b351c";
                          return (
                            <div
                              key={i}
                              style={{
                                width: "9%",
                                height: "8px",
                                borderRadius: ".2rem",
                                backgroundColor: isActive ? activeColor : inactiveColor,
                                transition: "background-color 0.3s ease-in-out"
                              }}
                            ></div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="mycard p-3 mt-2 position-relative">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center justify-content-center mycard" style={{width:'50px',height:'50px',backgroundColor:'#ff6b351c'}}>
                            <p className="fw-bold mb-0 text-prime"><FontAwesomeIcon icon={faChartSimple} style={{fontSize: '16px'}} /></p>
                          </div>
                          <div className="ms-2">
                            <p className="mb-0 fw-semibold lh-1" style={{fontSize:'14px'}}>Credit Score</p>
                            <p className="mb-0 fs-4" style={{fontWeight:'900',lineHeight:'120%'}}>{user?.credit_score}</p>
                            <p className="mb-0 lh-1" style={{fontSize:'14px',color:creditInfo.color}}>{creditInfo.label} rating</p>
                          </div>
                        </div>
                        <div className="position-absolute noneLabel" style={{maxWidth:'200px',width:'100%', top:'-20px', right:'0px'}}>
                          <GaugeComponent
                            type="semicircle"
                            minValue={300}
                            maxValue={850}
                            arc={{
                              colorArray: ['#FF2121', '#00FF15'],
                              padding: 0,
                              subArcs: [
                                { limit: 400 },
                                { limit: 500 },
                                { limit: 600 },
                                { limit: 700 },
                                { limit: 750 },
                                { limit: 800 },
                                { limit: 850 }
                              ]
                            }}
                            pointer={{ type: "blob", animationDelay: 1 }}
                            value={Number(user?.credit_score)}
                          />
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between">
                        <p className="mb-0" style={{fontSize:'14px'}}>Internal Risk Score</p>
                        <p className="mb-0 fw-bold text-prime" style={{fontSize:'14px'}}>{user?.internal_risk}/18.00</p>
                      </div>
                      <div className="rounded-pill" style={{height:'5px',backgroundColor:'gray'}}>
                        <div className="h-100 rounded-pill" style={{width: `${(Number(user?.internal_risk) / 18 ) * 100}%` ,backgroundColor:'#ff6b35'}}></div>
                      </div>
                      <div className="row">
                        <div className="col-6 g-3">
                          <div className="mycard p-2">
                            <div className="mb-2 rounded-pill d-flex justify-content-center py-2" style={{backgroundColor:'#ff6b350e'}}>
                              <p className="fw-bold mb-0 text-prime"><FontAwesomeIcon icon={faUsers} style={{fontSize: '16px', color:'#ff6b35ff'}} /></p>
                            </div>
                            <p className="fw-semibold text-center mb-3" style={{fontSize:'14px'}}>Community</p>
                          </div>
                        </div>
                        <div className="col-6 g-3">
                          <div className="mycard p-2">
                            <div className="mb-2 rounded-pill d-flex justify-content-center py-2" style={{backgroundColor:'#6c5dd31a'}}>
                              <p className="fw-bold mb-0 text-prime"><FontAwesomeIcon icon={faGraduationCap} style={{fontSize: '16px', color:'#6d5dd3ff'}} /></p>
                            </div>
                            <p className="mb-3 fw-semibold text-center" style={{fontSize:'14px'}}>Academy</p>
                          </div>
                        </div>
                        <div className="col-6 g-3">
                          <div className="mycard p-2">
                            <div className="mb-2 rounded-pill d-flex justify-content-center py-2" style={{backgroundColor:'#46bcaa1a'}}>
                              <p className="fw-bold mb-0 text-prime"><FontAwesomeIcon icon={faHeadset} style={{fontSize: '16px',color:'#46bcaaff'}} /></p>
                            </div>
                            <p className="mb-3 fw-semibold text-center" style={{fontSize:'14px'}}>Help Center</p>
                          </div>
                        </div>
                        <div className="col-6 g-3">
                          <div className="mycard p-2">
                            <div className="mb-2 rounded-pill d-flex justify-content-center py-2" style={{backgroundColor:'#ffcf521a'}}>
                              <p className="fw-bold mb-0 text-prime"><FontAwesomeIcon icon={faHeadset} style={{fontSize: '16px',color:'#ffce52ff'}} /></p>
                            </div>
                            <p className="mb-3 fw-semibold text-center" style={{fontSize:'14px'}}>Partner Directory</p>
                          </div>
                        </div>
                      </div>
                      <Link to="/improvescore" className="mt-2 myBtn rounded-pill px-3 py-2 fw-semibold text-center d-block" style={{fontSize:'14px'}}>Improve Score <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '12px'}} /></Link>
                    </div>
                </div>
                <div className="col-lg-8 col-md-6">
                  <div className="mycard p-3 mt-2 mt-lg-0">
                    <p className="mb-0 fw-bold" style={{fontSize:'14px'}}>Quick Loans</p>
                    <div className="rounded-4 p-3 mt-2" style={{border:'1px solid #ff6b35',backgroundColor:'#ff6b350c'}}>
                      <p className="mb-0 fw-bold text-prime" style={{fontSize:'14px'}}>0% interest at 50% LTV for 3 months</p>
                      <p className="mb-0" style={{fontSize:'14px'}}>Perfect for short-term liquidity needs</p>
                    </div>
                    <p className="mb-0 mt-2" style={{fontSize:'12px'}}>Our platform offers secure, transparent, and efficient decentralized lending with crypto collateral. Monitor your loans in real-time with our advanced risk management system.</p>
                  </div>
                  <div className="row my-2">
                    <div className="col-lg-4 col-12">
                      <div className="mycard p-3">
                        <div className="d-flex justify-content-between align-items-start">
                          <div className="d-flex align-items-center ">
                            <div className="d-flex align-items-center justify-content-center mycard" style={{width:'50px',height:'50px',backgroundColor:'#46bcaa15'}}>
                              <p className="fw-bold fs-4 mb-0" style={{color:'#46bcaa'}}>{getCurrencySymbol(user?.currency)}</p>
                            </div>
                            <div className="ms-2">
                              <p className="mb-0 fw-semibold lh-1" style={{fontSize:'14px'}}>Active Loans</p>
                              <p className="mb-0 fs-4" style={{fontWeight:'900',lineHeight:'120%'}}>{activeLoan.length}</p>
                              <p className="mb-0 lh-1" style={{fontSize:'14px'}}>/ {user?.noloan} maximum</p>
                            </div>
                          </div>
                          <div className="myBtn rounded-pill px-2 py-1 fw-bold d-inline-block" style={{fontSize:'13px',backgroundColor:'#46bcaa'}}>
                            {(activeLoan.length / Number(user?.noloan) * 100).toFixed(2)}% Used
                          </div>
                        </div>
                        <div className="d-flex justify-content-between mt-3">
                        {Array(10)
                          .fill()
                          .map((_, i) => {
                            const isActive = i < (activeLoan.length / Number(user?.noloan) * 100) / 10;
                            let activeColor, inactiveColor;
                            activeColor = "#46bcaa";
                            inactiveColor = "#46bcaa15";
                            return (
                              <div
                                key={i}
                                style={{
                                  width: "9%",
                                  height: "8px",
                                  borderRadius: ".2rem",
                                  backgroundColor: isActive ? activeColor : inactiveColor,
                                  transition: "background-color 0.3s ease-in-out"
                                }}
                              ></div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-8 col-12">
                      <div className="mycard p-3 p-4 mt-2 mt-lg-0">
                        <div className="row">
                          <div className="col-6" style={{borderRight:'1px solid #4b4b4b60'}}>
                              <p className="mb-0 text-secondary fw-semibold text-center" style={{fontSize:'14px'}}>Repaid</p>
                              <h4 className="mb-0 text-white text-center" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(paid * rate)}</h4>
                          </div>
                          <div className="col-6">
                              <p className="mb-0 text-secondary fw-semibold text-center" style={{fontSize:'14px'}}>Average Rate</p>
                              <h4 className="mb-0 text-white text-center" style={{fontWeight:'900'}}>{(borrowered ? (Number(interest) / Number(borrowered) * 100) : 0).toFixed(2)}%</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <LoanCalculator/>
                </div>
                <div className="col-12">
                    <p className="mt-2 fw-semibold text-secondary mb-0">Loan Offers ({loanOffer.length})</p>
                    <div className="row">
                        {loanOffer.map((loan) => (
                        <div className="col-xxl-3 col-lg-4 col-md-6 g-4">
                            <div className="mycard p-0 overflow-hidden">
                              <div className="d-flex align-items-center justify-content-center oveflow-hidden" style={{height:'100px'}}>
                                  <img src={`/uploads/${loan.photo}`} alt="profile" className="w-100 h-100" style={{objectFit: 'cover'}}/>
                              </div>
                              <div className="p-3">
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                  <p className="mb-0" style={{fontSize:'14px'}}>Loan Type</p>
                                  <p className="mb-0 text-prime text-uppercase" style={{fontWeight:'900'}}>{loan.title}</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                  <p className="mb-0" style={{fontSize:'14px'}}>Rate</p>
                                  <p className="mb-0 fw-bold">{loan.rate}%</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                  <p className="mb-0" style={{fontSize:'14px'}}>Duration:</p>
                                  <p className="mb-0 fw-bold">{loan.duration} {periodLabel(loan.period, loan.duration)}</p>
                                </div>
                                <hr/>
                                <div className="d-flex align-items-center justify-content-between">
                                  <p className="mb-0" style={{fontSize:'14px'}}>Range:</p>
                                  <p className="mb-0 fw-bold">{getCurrencySymbol(user?.currency)}{formatCurrency(loan.min * rate)} - {getCurrencySymbol(user?.currency)}{formatCurrency(loan.max * rate)}</p>
                                </div>
                                <hr/>
                                { (Number(user?.credit_score) > 740) ?
                                  (
                                    <Link to="/loanform" state={{loan_id: loan.loan_id, casset: 'Bitcoin', collateral: 0, collat : 'BTC'}} className="myBtn rounded-pill px-3 py-2 fw-semibold text-center d-block" style={{fontSize:'14px'}}>Get Loan <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '12px'}} /></Link>
                                  ) : (
                                    <Link to="/loandetails" 
                                    onClick={() => { 
                                      localStorage.setItem('deposit.loanID', loan.loan_id);
                                      localStorage.setItem('deposit.takeLoan', true);
                                    }}
                                    className="myBtn rounded-pill px-3 py-2 fw-semibold text-center d-block" style={{fontSize:'14px'}}>Get Loan <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '12px'}} /></Link>     
                                  )
                                }
                              </div>
                            </div>
                        </div>
                        ))}   
                    </div>
                </div>
                <div className="col-12">
                    <div className="mycard mt-2 mb-4">
                        <p className="fw-semibold text-secondary mb-2">My Loans ({allLoan.length})</p>
                        <div className="table-responsive">
                            <table className="table table-borderless table-dark align-middle">
                                {allLoan.length > 0 ? (
                                    allLoan.map((loan, index) => (
                                    <>
                                        <thead>
                                            <tr className="fs-7">  
                                                <th className="fw-normal text-secondary pb-0 d-md-table-cell d-none"></th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap">Total Debt ({loan.symbol})</th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap d-lg-table-cell d-none">Collateral Amount ({loan.c_symbol})</th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap d-lg-table-cell d-none">Residual Interest ({loan.symbol})</th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap">Rate</th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap d-md-table-cell d-none">Remaining Principal ({loan.symbol})</th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap d-lg-table-cell d-none">Date Started</th>
                                                <th className="fw-normal text-secondary pb-0 text-nowrap d-lg-table-cell d-none">Expired Date</th>
                                                <th className="fw-normal text-secondary pb-0">Status</th>
                                                <th className="fw-normal text-secondary pb-0 d-md-table-cell d-none"></th>
                                                <th className="fw-normal text-secondary pb-0 d-lg-table-cell d-none"></th>
                                            </tr>
                                        </thead>
                                        <tbody style={{fontSize: '14px'}}>
                                            <LoanHistory index={index} loan={loan}/>
                                            <tr>
                                              <td className="p-0" colSpan={10}><hr className="my-0"/></td>
                                            </tr>
                                        </tbody>
                                    </>
                                    )) 
                                    ) : (
                                    <tbody style={{fontSize: '14px'}}>
                                        <tr>
                                            <td colSpan={5}>No loan records yet.</td>
                                        </tr>
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-cemter overflow-x-auto mx-2 mb-2" style={{cursor:'pointer'}}>
              <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab === "documents" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab === "documents" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab("documents");}}>Documents</h6>
              <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab === "payments" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab === "payments" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab("payments");}}>Payments</h6>
              <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab === "disbursements" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab === "disbursements" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab("disbursements");}}>Disbursements</h6>
              <h6 className="mb-0 fw-semibold py-2 me-3" style={{color: activeTab === "collateral" ? 'white' : 'gray', fontSize: '16px', borderBottom: activeTab === "collateral" ? '2px solid #ff6b35' : 'none'}} onClick={() => {setActiveTab("collateral");}}>Collateral</h6>
            </div>
            {activeTab === "documents" && (
                <div className="row">
                    <div className="col-lg-6 col-xxl-4">
                        <div className="mycard">
                            <label className="fw-semibold mb-2" style={{fontSize: '14px'}}>File Name:</label>
                            <div className="d-flex align-items-center form-control justify-content-between py-2 pe-2">
                                <input 
                                    type="text"
                                    placeholder={"Document name"}
                                    className="inputNone"
                                    value={fileType}
                                    onChange={(e) => setFileType(e.target.value)}
                                />
                            </div>
                            <label className="fw-semibold mb-0 mt-2" style={{fontSize: '14px'}}>
                                Upload documents required for loan
                            </label>
                            <div className="form-text mb-2" style={{ fontSize: '12px', color: '#6c757d' }}>
                            Accepted: PDF, JPG, PNG. Max size: 5 MB per file. Up to 3 files. (e.g. ID, proof of income, bank statement)
                            </div>
                            <FilePond
                            files={files}
                            onupdatefiles={setFiles}
                            allowMultiple={false}
                            maxFiles={3}
                            name="file"
                            labelIdle="Click here to upload"
                            server={{
                                process: (fieldName, file, metadata, load, error, progress, abort) => {
                                const formData = new FormData();
                                formData.append("file", file);
                                const request = new XMLHttpRequest();
                                request.open("POST", `${process.env.REACT_APP_API_URL}controller/upload1.php`);
                                request.upload.onprogress = (e) => {
                                    progress(e.lengthComputable, e.loaded, e.total);
                                };
                                request.onload = () => {
                                    const res = JSON.parse(request.responseText);
                                    if (res.success) {
                                    setFileName(res.filename);
                                    load(res.filename);
                                    } else {
                                    error(res.error || "Upload failed");
                                    }
                                };
                                request.onerror = () => {
                                    error("Upload error");
                                };
                                request.send(formData);
                                return {
                                    abort: () => {
                                    request.abort();
                                    abort();
                                    }
                                };
                                },
                                revert: (serverId, load, error) => {
                                fetch(`${process.env.REACT_APP_API_URL}controller/delete.php`, {
                                    method: "POST",
                                    headers: {
                                    "Content-Type": "application/json"
                                    },
                                    body: JSON.stringify({ filename: fileName })
                                })
                                    .then((res) => res.json())
                                    .then((data) => {
                                    if (data.success) {
                                        setFileName("");
                                        setFiles([]);
                                        load();
                                    } else {
                                        error(data.error || "Failed to delete file");
                                    }
                                    })
                                    .catch(() => {
                                    error("Delete request failed");
                                    });
                                }
                            }}
                            />
                            <div className={`myBtn w-100 text-center mt-3 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? ValidateUpload : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Upload'}</div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xxl-8">
                        <div className="mycard">
                            {documents.map((document) => (
                            <div className="col-xxl-3 col-lg-4">
                                <div className="d-flex align-items-center">
                                    <img src={require(`../images/pngwing.com.png`)} alt="chart" style={{width: '120px'}}/>
                                    <div>
                                        <h6 className="fw-bold mb-0">{document.file_name}</h6>
                                        <p className="mb-0 mt-2" style={{fontSize:'14px'}}><span className="text-secondary">Uploaded:</span> <br/> {document.date}</p>
                                    </div>
                                </div>
                                <div className="mt-2 d-flex align-items-center">
                                    <div className="px-3 py-2 d-flex align-items-center rounded-2 me-2" style={{backgroundColor: '#ffffff06', textDecoration:'none', cursor:'pointer'}} onClick={() => downloadFile(document.doc, document.file_name)} role="button" aria-label={`Download ${document.file_name}`}>
                                        <FontAwesomeIcon className="text-prime me-2" icon={faDownload} style={{fontSize: '14px'}} />
                                        <p className="mb-0 fw-semibold text-prime" style={{fontSize: '12px'}}>Download</p>
                                    </div>
                                    <div className="px-3 py-2 d-flex align-items-center rounded-2 cursor-pointer" style={{backgroundColor: '#ffffff06',textDecoration:'none',cursor:'pointer'}} onClick={() => deleteFile(document.id)}>
                                        <FontAwesomeIcon className="text-prime me-2" icon={faTrash} style={{fontSize: '14px'}} />
                                        <p className="mb-0 fw-semibold text-prime" style={{fontSize: '12px'}}>Delete</p>
                                    </div>
                                </div>
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
            {activeTab === "payments" && (
                <div className="row">
                    <div className="col-12">
                        <div className="mycard mt-2" style={{minHeight: '270px'}}>
                            <div className="d-flex align-items-center mb-4">
                                <h6 className="mb-0 text-white me-3" style={{fontSize: '18px'}}>Payment Records</h6>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-dark align-middle">
                                <thead>
                                    <tr className="fs-7">
                                    <th className="fw-normal text-light">Reference</th>
                                    <th className="fw-normal text-light">Method</th>
                                    <th className="fw-normal text-light">Amount</th>
                                    <th className="fw-normal text-light">Amount (USDT)</th>
                                    <th className="fw-normal text-light">Date</th>
                                    <th className="fw-normal text-light">Status</th>
                                    </tr>
                                </thead>
                                <tbody style={{fontSize: '14px'}}>
                                    {payments.length > 0 ? (
                                        payments.map((payment) => (
                                        <tr>
                                            <td>#{payment.reference}</td>
                                            <td className="text-nowrap">
                                                <span className="text-nowrap px-2 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520'}}>{payment.method}</span>
                                            </td>
                                            <td className="fw-semibold text-nowrap"><img src={payment.logo} alt="Asset" style={{width: '30px'}}/> {payment.amount}</td>
                                            <td className="text-nowrap">{payment.amountUSDT}</td>
                                            <td className="text-nowrap">{payment.date}</td>
                                            <td><span className={`${payment.status === 'pending' ? 'status-warning' : payment.status === 'failed' ? 'status-danger' : 'status-success'}`}>{payment.status.charAt(0).toUpperCase() + payment.status.slice(1)}</span></td>
                                        </tr>
                                        )) 
                                        ) : (
                                        <tr>
                                            <td colSpan={5}>No payments records yet.</td>
                                        </tr>
                                    )}
                                </tbody>
                                </table>
                            </div>
                        </div>
                    </div> 
                </div>
            )}
            {activeTab === "disbursements" && (
                <div className="row">
                    <div className="col-12">
                        <div className="mycard mt-2" style={{minHeight: '270px'}}>
                            <div className="d-flex align-items-center mb-4">
                                <h6 className="mb-0 text-white me-3" style={{fontSize: '18px'}}>Disbursements</h6>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-dark align-middle">
                                <thead>
                                    <tr className="fs-7">
                                    <th className="fw-normal text-light">Reference</th>
                                    <th className="fw-normal text-light">Loan Type</th>
                                    <th className="fw-normal text-light">Rate</th>
                                    <th className="fw-normal text-light">Duration</th>
                                    <th className="fw-normal text-light">Method</th>
                                    <th className="fw-normal text-light">Amount</th>
                                    <th className="fw-normal text-light">Interest</th>
                                    <th className="fw-normal text-light">Collateral</th>
                                    <th className="fw-normal text-light">Date</th>
                                    <th className="fw-normal text-light">Start Date</th>
                                    <th className="fw-normal text-light">Expired Date</th>
                                    <th className="fw-normal text-light">Status</th>
                                    </tr>
                                </thead>
                                <tbody style={{fontSize: '14px'}}>
                                    {countedLoan.length > 0 ? (
                                        countedLoan.map((loan) => (
                                        <tr>
                                            <td>#{loan.reference}</td>
                                            <td className="text-nowrap">{loan.offer.title}</td>
                                            <td className="text-nowrap">
                                                <span className="text-nowrap px-2 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520'}}>{loan.interest_rate}%</span>
                                            </td>
                                            <td className="text-nowrap">{loan.duration} Days</td>
                                            <td className="text-nowrap">
                                                <span className="text-nowrap px-2 py-1 rounded-pill text-warning" style={{backgroundColor: 'rgba(255, 183, 0, 0.15)'}}>{loan.method}</span>
                                            </td>
                                            <td className="fw-semibold text-nowrap"><img src={loan.logo} alt="Asset" style={{width: '30px'}}/> {loan.amount}</td>
                                            <td className="fw-semibold text-nowrap"><img src={loan.logo} alt="Asset" style={{width: '30px'}}/> {loan.interest_amount}</td>
                                            <td className="fw-semibold text-nowrap"><img src={loan.c_logo} alt="Asset" style={{width: '30px'}}/> {loan.collateral}</td>
                                            <td className="text-nowrap">{loan.date}</td>
                                            <td className="text-nowrap">{loan.start}</td>
                                            <td className="text-nowrap">{loan.expired}</td>
                                            <td><span className={`${loan.status === 'pending' ? 'status-warning' : loan.status === 'overdue' || loan.status === 'rejected' ? 'status-danger' : 'status-success'}`}>{loan.status.charAt(0).toUpperCase() + loan.status.slice(1)}</span></td>
                                        </tr>
                                        )) 
                                        ) : (
                                        <tr>
                                            <td colSpan={5}>No disbursements records yet.</td>
                                        </tr>
                                        )}
                                </tbody>
                                </table>
                            </div>
                        </div>
                    </div> 
                </div>
            )}
            {activeTab === "collateral" && (
            <div className="row">
                <div className="col-xxl-6 col-lg-9">
                    <div className="mycard">
                        <h5 className="mb-3 fw-bold">Accepted collateral</h5>
                        <div className="d-flex align-items-center w-100" style={{gap:'10px', overflowX: 'auto', cursor:'pointer'}}>
                            {assetsData.map((asset) => (
                            <div
                                key={asset.symbol}
                                className="overflow-hidden rounded-2 d-flex align-items-center justify-content-center overflow-hidden"
                                style={{
                                width: '40px',
                                height: '40px',
                                minWidth: '40px',
                                minHeight: '40px',
                                backgroundColor: collat === asset.symbol ? '#ff6b35' : '#ffffff1c'
                                }}
                                onClick={() => {
                                setCollat(asset.symbol);
                                getBalanceBySymbol(asset.symbol);
                                }}
                            >
                                <img 
                                    src={asset.image} 
                                    alt={asset.name} 
                                    style={{width: '25px'}} 
                                />
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-xxl-2 col-lg-3">
                    <div className="mycard mt-3 mt-lg-0">
                        <p className="mb-0 text-secondary fw-semibold">Balance</p>
                        <h2 className="mb-0 fw-bold">{parseFloat(coinBal).toFixed(4)} {collat}</h2>
                        <p className="mb-0 text-secondary fw-semibold">In Wallet</p>
                    </div>
                </div> 
                <div className="col-12">
                    <div className="mycard mt-2" style={{minHeight: '270px'}}>
                        <div className="d-flex align-items-center mb-2">
                            <h6 className="mb-0 text-white me-3" style={{fontSize: '18px'}}>Collaterals</h6>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-borderless table-dark align-middle">
                            <thead>
                                <tr className="fs-7">
                                <th className="fw-normal text-light">Reference</th>
                                <th className="fw-normal text-light">Loan</th>
                                <th className="fw-normal text-light">Method</th>
                                <th className="fw-normal text-light">Amount</th>
                                <th className="fw-normal text-light">Date</th>
                                <th className="fw-normal text-light">Status</th>
                                </tr>
                            </thead>
                            <tbody style={{fontSize: '14px'}}>
                                {collateral.length > 0 ? (
                                    collateral.map((collat) => (
                                    <tr>
                                        <td>#{collat.reference}</td>
                                        <td className="text-nowrap">
                                            <span className="text-nowrap px-2 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520'}}>{collat.method}</span>
                                        </td>
                                        <td className="fw-semibold text-nowrap"><img src={collat.logo} alt="Asset" style={{width: '30px'}}/> {collat.amount}</td>
                                        <td className="text-nowrap">{collat.date}</td>
                                        <td><span className={`${collat.status === 'pending' ? 'status-warning' : collat.status === 'failed' ? 'status-danger' : 'status-success'}`}>{collat.status.charAt(0).toUpperCase() + collat.status.slice(1)}</span></td>
                                    </tr>
                                    )) 
                                ) : (
                                <tr>
                                    <td colSpan={5}>No collaterals records yet.</td>
                                </tr>
                                )}
                            </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            )}
          </main>
        </div>
      </div>
    </div>
  )
}

export default Loan